import { useEffect } from 'react'
import { fetchActivitySummary } from '../../../effects'
import { useActivitySummaryContext } from '../../../context'
import { setActivitySummaryTableStateActionCreator as setTableState } from '../../../state'

export function useFetchData() {
  const [state, dispatch] = useActivitySummaryContext()

  const {
    activeTab,
    tableState: {
      paginationState: { page, pageSize },
    },
    filterSet: { normalizedFilters, orderBy },
  } = state

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      dispatch(setTableState({ loading: true }))

      const action = await fetchActivitySummary({
        page,
        orderBy,
        pageSize,
        tab: activeTab,
        normalizedFilters,
      })

      if (mounted) {
        dispatch(action)
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [activeTab, dispatch, normalizedFilters, orderBy, page, pageSize])
}
